import CallDispositionChipsView from './DispositionChips'

export const DispositionChips = CallDispositionChipsView

export default CallDispositionChipsView
